import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'

// パートナー設定の注文に関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsCustomerOrderPart(spec: ServiceSpecification) {
  return {
    get useAlternativePicking(): boolean {
      return spec.customerOrder?.customerRequest?.enableStockOutAlternative === true
    },
    get displayLinkToNewProductInOrder(): boolean {
      return spec.customerOrder?.enableStaffProductAddition === true
    },
  }
}
